export default function StatsSection() {
  const stats = [
    { value: '100,000+', label: '漫画总量', icon: 'ri-book-open-line' },
    { value: '1,200万+', label: '日活跃用户', icon: 'ri-user-heart-line' },
    { value: '50亿+', label: '累计阅读量', icon: 'ri-eye-line' },
    { value: '每日更新', label: '更新频率', icon: 'ri-refresh-line' },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20shapes%2C%20coral%20and%20golden%20hues%2C%20digital%20art%20style%2C%20minimalist%20and%20clean%2C%20subtle%20texture%2C%20professional%20look&width=1800&height=600&seq=stats-bg-hanman&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-primary-500/90"></div>
      <div className="relative z-10 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-background-50">
            韩漫之家 · 数据一览
          </h2>
          <p className="text-sm text-background-100/80 mt-2">数百万读者的共同选择</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
                <i className={`${stat.icon} text-background-50 text-2xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
              <div className="text-sm text-background-100/80 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}